import smartAuthAPI from '../smartbestbuys-api'
import { errorHandler } from '../../middleware'

export const getCustomerPORefs = errorHandler<string[]>(async (customerId: number) => {
  const path = `/customers/${customerId}/po-references`
  return await smartAuthAPI.get(path)
})
